// Texty košíka a pokladne — slovenské dvojča locale/cs/checkoutPage.js.
import { NBSP } from '../../modules/money.js';
import { plural } from '../plural.js';

export default {
  continueShopping: 'Pokračovať v nákupe',
  relatedMore: 'Súvisiace produkty',
  servicesTitle: 'Voliteľné doplnkové služby',
  servicesNote: 'nie je nutné na dokončenie objednávky',
  giftLabel: 'Darček',
  sumTitle: 'Rekapitulácia objednávky',
  hintNext: 'Doprava a platba v ďalšom kroku',
  goodsLabel: 'Tovar celkom',
  savedLabel: 'Ušetrili ste ',
  totalLabel: 'Celkom k úhrade',
  notePlaceholder: 'Vaša poznámka…',
  pickNote: 'Bez zvoleného výdajného miesta nie je možné pokračovať.',
  couponApply: 'Použiť',
  couponPlaceholder: 'Zľavový kupón',
  ctaCart: 'Pokračovať k doprave',
  ctaShipping: 'Pokračovať k údajom',
  backShipping: 'Späť do košíka',
  backInfo: 'Späť k doprave',
  paySecure: 'Zabezpečené a šifrované',
  shipTitle: 'Spôsob dopravy',
  payTitle: 'Spôsob platby',
  contactTitle: 'Kontaktné údaje',
  cartPickupLead: 'Vyzdvihnutie možné od:',
  trustSecureTitle: 'Bezpečná platba',
  trustSecureText: 'SSL certifikát a 3D Secure',
  trustFreeShipTitle: 'Doprava zadarmo',
  trustReturnTitle: '14 dní na vrátenie',
  trustReturnText: 'Bez udania dôvodu',
  trustHelpTitle: 'Poradíme s výberom',
  trustShopTitle: 'Overený obchod',
  // na SK se dlaždice nekreslí (manifest `reviews.checkoutTile: false`),
  // místo ní jde `trustShipFrom*` s cenou z ceníku
  trustShopText: (pct) => 'Na Heureke nás odporúča ' + pct + '\u00A0% zákazníkov',
  trustShipFromTitle: 'Doprava po celom Slovensku',
  trustShipFromText: (from) => 'od ' + from,
  freeShipping: (from, kg) => 'Na výdajné miesto nad ' + from + ' do ' + kg + NBSP + 'kg',
  footTerms: 'Obchodné podmienky',
  footShipping: 'Doprava a platba',
  footPrivacy: 'Ochrana osobných údajov',
  footContact: 'Kontakty',
  emptyTitle: 'Váš košík je prázdny',
  emptyText: 'Vyberte si z viac ako 5 000 kusov náradia, záhradnej techniky a vybavenia do dielne.',
  emptyCta: 'Späť do obchodu',
  items: (n) => n + ' ' + plural(n, ['položka', 'položky', 'položiek']),
  helpCall: (phone) => 'Zavolať ' + phone,
  helpMail: (email) => 'Napísať ' + email,
  helpHours: (hours) => hours + ', poradíme',
  msHeadBoth: 'Máte darček aj dopravu zadarmo',
  msHeadGift: 'Máte darček zadarmo',
  msHeadShip: 'Máte dopravu zadarmo',
  msHeadNone: 'Vaše výhody k objednávke',
  msSubShip: (left) => 'Ešte ' + left + ' do dopravy zadarmo',
  msSubGift: (left) => 'Ešte ' + left + ' do darčeka',
  msSubGoods: (goods) => 'Hodnota tovaru ' + goods,
  msLabelGift: 'Darček zadarmo',
  msLabelShip: 'Doprava zadarmo',
  msShipKg: (kg) => ' · do ' + kg + NBSP + 'kg',
  msBarLabel: 'Postup k výhodám objednávky',
  cartTitle: 'Nákupný košík',
  removeItem: 'Odstrániť z košíka',
  free: 'Zadarmo',
  priceFrom: (price) => 'od ' + price,
  etaToday: (dm) => 'dnes ' + dm,
  etaDays: ['v nedeľu', 'v pondelok', 'v utorok', 'v stredu', 'vo štvrtok', 'v piatok', 'v sobotu'],
  // SK: neověřeno ve fixtures (hláška serveru „Odberné miesto … nebolo vybrané")
  pickupMissingRe: /nebolo vybr/i,
  donePayLabel: 'Údaje k platbe',
  ctaFallback: 'Pokračovať',
  promoTag: (until) => 'Akcia do ' + until,
  promoLine: (carrier, price, maxKg, until) =>
    'Akcia: ' + carrier + ' na výdajné miesto do ' + maxKg + NBSP + 'kg za ' + price + ', platí do ' + until.replace(/\.$/, '') + '.',
};
